import { useContext } from 'react';
import { LocaleContext } from '../locale-provider';
import {
  GetImpersonateTextsQuery,
  useGetImpersonateTextsQuery
} from './queries.cms.generated';

type Common = NonNullable<
  NonNullable<GetImpersonateTextsQuery['common']>['data']
>['attributes'];

export function useImpersonateLocales(): Common | undefined {
  const { locale } = useContext(LocaleContext);
  const { data: cmsData } = useGetImpersonateTextsQuery({
    locale
  });
  const cms = cmsData
    ? {
        ...(cmsData.common?.data?.attributes ?? {})
      }
    : undefined;
  return cms as Common | undefined;
}
